import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { withTranslation } from 'react-i18next'

import { getActivityId } from 'store/entities/activity/selectors'
import { getIdentityUserId, isSocialActivatedForIdentityOrganization } from 'store/entities/identity/selectors'

import { getUIWindowSizesWidth } from 'store/entities/ui/selectors'
import SocialPopoverWithButton from './SocialPopoverWithButton'

const mapStateToProps = createStructuredSelector({
  activityId: getActivityId,
  identityId: getIdentityUserId,
  windowWidth: getUIWindowSizesWidth,
  isSocialActivated: isSocialActivatedForIdentityOrganization,
})

export default connect(mapStateToProps, null)(withTranslation()(SocialPopoverWithButton)) as any
